module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_medium.36c373e0.webp";